import React from 'react'
import { IconName } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const MatchMessageCardflagLabel = (info: string|null, icon: IconName) => {
  if(!info) return <></>

  return (
    <li
      className="inline-flex rounded-lg space-x-1.5 items-center flex-shrink-0"
    >
      { icon && <FontAwesomeIcon icon={['far', icon]} className={`w-4 center text-secondary`} />}
      <span className="text-xxs font-semibold uppercase tracking-wide">
        {info}
      </span>
    </li>
  )
};